import {ApprovalStatus, Approver} from '@domain/shifthandover'
import {UseMutationResult} from '@tanstack/react-query'
import {ApproversBanner as ApproversBannerCommon} from '@widgets/common-approvers'
import {AxiosError} from 'axios'
import React, {FC, useState} from 'react'

type ApproversBannerProps = {
  plantId: string
  eventId: string
  approvers?: Approver[]
  useApprovalHook: (params: {
    plantId: string
  }) => UseMutationResult<unknown, AxiosError, {eventId: string; approvalStatus: ApprovalStatus}>
}

export const ApproversBanner: FC<ApproversBannerProps> = ({
  plantId,
  useApprovalHook,
  eventId,
  approvers
}) => {
  const [pendingAction, setPendingAction] = useState<ApprovalStatus>()

  const {mutate: updateStatus, isPending: isLoading} = useApprovalHook({plantId})
  const onStatusChange = (status: ApprovalStatus) => {
    setPendingAction(status)
    updateStatus(
      {eventId, approvalStatus: status},
      {
        onSettled: () => setPendingAction(undefined)
      }
    )
  }

  return (
    <ApproversBannerCommon
      plantId={plantId}
      approvers={approvers}
      eventId={eventId}
      onStatusChange={onStatusChange}
      pendingAction={pendingAction}
      isLoading={isLoading}
    />
  )
}
